module.exports = __webpack_public_path__ + "img/videoStop.bbcb7d3a.svg";